<div style="text-align: -webkit-center;text-align: -moz-center; margin-top: 3rem;">

    <div class="card" style="margin: 16px; text-align: center; width: 70%; min-width: 30rem; ">


        <!--SPINNER WHILE LOADING PAGE-->
        <div *ngIf="loadingPage" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <!--ALREADY DONE TEST-->
        <div *ngIf="!valid  && !loadingPage">
            <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_TEST' | translate}} </p>
        </div>

        <div *ngIf="valid  && !loadingPage">
            <!--INSTRUCTIONS-->
            <div *ngIf="!started">
                <h1 *ngIf="!testFinished" style="font-size: 3em;">{{'FB_T1' | translate}}</h1>
                <div *ngIf="!demoFinished && !testFinished" style="text-align: -webkit-center;text-align: -moz-center;">
                    <p> {{'FB_P1' | translate}} </p>
                    <!-- <p>
                        <button (click)="playCustomBeep()">play custom beep</button>
                        <button (click)="playBeep()">play original beep</button>
                    </p> -->
                    <div
                        style="display: flex; justify-content: center; margin-top: 1rem; font-family: akzidenz-grotesk-roman; ">
                        <div style=" font-size: large;">
                            {{'SELECT_AUDIO' | translate}}
                            <br />
                            <mat-radio-group>
                                <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">
                        
                                    <mat-radio-button [checked]="audioSource === 'headphones'" (change)="setAudioType($event.value)"
                                        value="headphones">
                                        {{'HEADPH' | translate}}
                                    </mat-radio-button>
                                </div>
                                <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">
                                    <mat-radio-button [checked]="audioSource === 'speakers'" (change)="setAudioType($event.value)"
                                        value="speakers">
                                        {{'SPEAKERS' | translate}}
                                    </mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                    <br><br>
                    <button mat-raised-button class="button" (click)="start()"
                        matTooltip="{{'AUDIO_TOOLTIP' | translate}}" [matTooltipDisabled]="audioSource"
                        [disabled]="!audioSource">
                        {{'START' | translate}}
                    </button>

                </div>

                <div *ngIf="demoFinished && !testFinished" style="margin-top: 2rem;">
                    <p>
                        {{'FB_P2' | translate}}
                    </p>
                    <p>
                        {{'FB_P3' | translate}}
                    </p>
                    <button mat-raised-button class="button" (click)="start()">
                        {{'START' | translate}}
                    </button>
                </div>
                <div *ngIf="testFinished" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
                    <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">{{'SUCCESS_TEST' | translate}}</p>
                </div>
            </div>


            <!--TEST VIEW-->
            <div *ngIf="started && isFullScreen" style="text-align: -webkit-center;text-align: -moz-center;">
                <div *ngIf="demo"
                    style="display: flex; background-color: #333333; width: fit-content; padding: 0px 8px; margin-bottom: 2rem;  font-size: 1.5em; justify-content: center;">
                    <p
                        style="font-family: akzidenz-grotesk-bold; font-size: 30px; color: white; margin: 8px 0px;">
                        {{'FB_P4' | translate}} </p>
                </div>
                <div *ngIf="!demo"
                    style="display: flex;  width: fit-content; margin-bottom: 2rem; padding: 0px 8px; font-size: 1.5em; justify-content: center;">
                    <div>
                        <p
                            style="font-family: akzidenz-grotesk-bold; font-size: 30px; color: black; margin: 8px 0px;">
                            {{'FB_P8' | translate}} </p>
                    </div>
                </div>
                <p style="font-size: large; font-family: akzidenz-grotesk-roman;">
                    {{'FB_P5' | translate}}
                </p>
                <p style="font-size: x-large; font-family: akzidenz-grotesk-bold;">
                    {{'FB_P6' | translate}}
                    </p>
                <div *ngIf="(demo && !loadingDemo) || (!demo && !loadingTrials)">
                    <p *ngIf="!demo" style="font-size: x-large; margin-bottom: 0;">{{'ROUND' | translate}}: {{trials[round].trialNum +
                        1}} / {{120}}</p>
                    <p *ngIf="demo" style="font-size: x-large; margin-bottom: 0;">{{'ROUND' | translate}}: {{round +
                        1}} / {{8}}</p>
                    <div *ngIf="startaf">
                        <button mat-raised-button [disabled]="!waitingResponse" (click)="pressKey('sound')"
                            color="white"
                            style="margin-right: 1rem;background-color: #622567;color: white;margin-top: 1rem;">
                            Beep
                        </button>
                        <button mat-raised-button [disabled]="!waitingResponse" (click)="pressKey('light')"
                            color="white" style="background-color: #622567;color: white;margin-top: 1rem;">
                            Flash
                        </button>
                    </div>
                    <div *ngIf="!startaf">
                        <button mat-raised-button (click)="startAfter()" color="white"
                            style="margin-right: 1rem;background-color: #622567;color: white;margin-top: 1rem;">
                            {{'START' | translate}}
                        </button>
                        <button *ngIf="demo" mat-raised-button (click)="openInstructions()" color="white"
                            style="margin-right: 1rem;background-color: #622567;color: white;margin-top: 1rem;">
                            {{'FB_P7' | translate}}
                        </button>
                    </div>
                </div>

                <!--SPINNER IF LOADING TRIALS-->
                <div *ngIf="(demo && loadingDemo) || (!demo && loadingTrials)">
                    <div style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
                        <mat-spinner diameter="30"></mat-spinner>
                    </div>
                </div>
                <div style="height: 17rem; padding: 2rem 0;">
                    <div id="blink-div" class='circle' style="display: none;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>